module.exports = __webpack_public_path__ + "img/61.d664fd3e.jpg";